import { api } from './BaseService'

export const getTailors = async () => {
    return await api.get(`/tailors`)
}

export const getTailorById = async (id) => {
    return await api.get(`/tailors/${id}`)
}

export const createTailor = async (data) => {
    return await api.post(`/tailors`, data)
}
export const updateTailor = async (data) => {
    return await api.put(`/tailors/${data?.id}`, data)
}
export const deleteTailor = async (id) => {
    return await api.delete(`/tailors/${id}`)
}
